export const GET_SKILL_GROUP = 
    `query {
        getServiceCategory_ {
        message
            category {
                id
                nameCategory
                photo
                skill {
                    id_skill
                    name
                    photo
                }
            }
        }
    }`;

export const GET_GROUPS = `
    query {
        getServiceCategory{
            message
            category {
                id
                name 
                photo
            }
        }
    }
`;

export const GET_ID_GROUPS = `
    query {
        groupId($id: String!) {
            groupId(id: $id) {
                message
                group {
                    id
                    name
                    photo
                }
            }
        }
    }
`;

export const GET_SKILLS = `
    query {
        getAllSkills {
            id_skill
            name
        }
    }
`;

export const GET_ACTIVITY = `
    query {
        getActivity {
            id
            description
        }
    }
`;

export const GET_CITY = `
    query {
        getAllCities {
            id_city
            name
        }
    }
`;